import formatCurrency from "format-currency";

class OverdueByContractModalController {
  constructor($uibModalInstance, overdueByContract, overdueInvoicesEntriesLoaded) {
    "ngInject";
    this.$uibModalInstance = $uibModalInstance;
    
    // Get data from resolve (passed when opening modal)
    this.overdueByContract = overdueByContract || {};
    this.overdueInvoicesEntriesLoaded = overdueInvoicesEntriesLoaded || false;
    
    // Convert object to array for sorting and pagination
    this.contractsArray = [];
    let total = 0;
    if(this.overdueByContract) {
      Object.keys(this.overdueByContract).forEach((contract) => {
        const amount = this.overdueByContract[contract];
        this.contractsArray.push({
          contract: contract,
          amount: amount
        });
        total += amount;
      });
    }
    this.totalAmount = '$ ' + formatCurrency(total);
    
    // Sorting
    this.sortColumn = 'amount';
    this.sortReverse = true; // Default to descending by amount
    
    // Pagination
    this.currentPage = 1;
    this.itemsPerPage = 10;
  }

  formatCurrency(value) {
    return '$ ' + formatCurrency(value);
  }

  sortBy(column) {
    if(this.sortColumn === column) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortColumn = column;
      this.sortReverse = column === 'amount'; // Default to descending for amount, ascending for contract name
    }
    this.currentPage = 1; // Reset to first page when sorting changes
  }

  getSortClass(column) {
    if(this.sortColumn === column) {
      return this.sortReverse ? 'fa-sort-down' : 'fa-sort-up';
    }
    return 'fa-sort';
  }

  getPaginatedContracts() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.getSortedContracts().slice(start, end);
  }

  getSortedContracts() {
    const sorted = this.contractsArray.slice();
    sorted.sort((a, b) => {
      let aVal, bVal;
      if(this.sortColumn === 'amount') {
        aVal = a.amount;
        bVal = b.amount;
      } else {
        aVal = a.contract.toLowerCase();
        bVal = b.contract.toLowerCase();
      }
      
      if(aVal < bVal) {
        return this.sortReverse ? 1 : -1;
      }
      if(aVal > bVal) {
        return this.sortReverse ? -1 : 1;
      }
      return 0;
    });
    return sorted;
  }

  getTotalPages() {
    return Math.ceil(this.contractsArray.length / this.itemsPerPage);
  }

  getStartIndex() {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getEndIndex() {
    return Math.min(this.currentPage * this.itemsPerPage, this.contractsArray.length);
  }

  prevPage() {
    if(this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage() {
    if(this.currentPage < this.getTotalPages()) {
      this.currentPage++;
    }
  }

  close() {
    this.$uibModalInstance.close();
  }
}

export default OverdueByContractModalController;



// WEBPACK FOOTER //
// ./client/common/modals/OverdueByContractModal/overdueByContractModal.controller.js